import { IconButton, IconInfo } from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

import { CareCircleInfoDialog } from './CareCircleInfoDialog';

export const CareCircleInfoButton = () => {
    const [showDialog, { open, close }] = useDisclosure(false);

    return (
        <>
            <IconButton withStyles={false} Icon={IconInfo} onClick={open} />
            <CareCircleInfoDialog isOpen={showDialog} onClose={close} />
        </>
    );
};
